import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

import NProgress from "vue-nprogress";
import VueAlertify from "vue-alertify";
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import "tiptap-vuetify/dist/main.css";
import "vuetify/dist/vuetify.min.css";
import './registerServiceWorker'

Vue.use(TiptapVuetifyPlugin, {
  vuetify: vuetify, // same as "vuetify: vuetify"
  iconsGroup: "mdi",
});

Vue.config.productionTip = false;

Vue.use(NProgress);
Vue.use(VueAlertify);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
